import { Deserializable } from './deserializable.model';
import { PhotoThumbnail } from './photo-thumbnail.model';

export interface ComingSoonPhotoThumbnails {
  [size: string]: PhotoThumbnail;
}

export class ComingSoonPhoto implements Deserializable<ComingSoonPhoto> {
  uri: string;
  order: number;
  uploadedBy: string;
  photographerId?: string;
  height?: number;
  width?: number;
  thumbnails: ComingSoonPhotoThumbnails;
  filename?: string;
  fileExtension?: string;

  constructor(photo?: Partial<ComingSoonPhoto>) {
    this.thumbnails = {};
    if (photo) {
      this.deserialize(photo);
    }
  }

  deserialize(photo: Partial<ComingSoonPhoto>): ComingSoonPhoto {
    Object.assign(this, photo);
    if (photo.thumbnails) {
      this.thumbnails = { ...photo.thumbnails };
    }
    return this;
  }
}

export class ComingSoon implements Deserializable<ComingSoon> {
  photos: ComingSoonPhoto[];
  propertyDescription: string | null;
  companyUrl: string | null;
  mlsNumber: string | null;
  mlsEntryDate: string | null; // ISO date string YYYY-MM-DD
  mlsEntryFailed: boolean;
  mlsEntryFailureReason: string | null;
  campaignStartedAt: string | null;

  constructor(data?: Partial<ComingSoon>) {
    this.photos = [];
    this.propertyDescription = null;
    this.companyUrl = null;
    this.mlsNumber = null;
    this.mlsEntryDate = null;
    this.mlsEntryFailed = false;
    this.mlsEntryFailureReason = null;
    this.campaignStartedAt = null;

    if (data) {
      this.deserialize(data);
    }
  }

  deserialize(data: Partial<ComingSoon>): ComingSoon {
    Object.assign(this, data);
    if (data.photos) {
      this.photos = data.photos.map((photo) => new ComingSoonPhoto(photo));
    }
    return this;
  }

  /**
   * Converts this model to the format expected by the PUT API
   */
  toUpdatePayload(): ComingSoonUpdatePayload {
    return {
      photos: this.photos.map((photo) => ({
        uri: photo.uri,
        uploadedBy: photo.uploadedBy,
        photographerId: photo.photographerId || null,
        height: photo.height || null,
        width: photo.width || null,
        thumbnails: photo.thumbnails || {},
        filename: photo.filename || null,
        fileExtension: photo.fileExtension || null,
      })),
      propertyDescription: this.propertyDescription,
      companyUrl: this.companyUrl,
      mlsNumber: this.mlsNumber,
      mlsEntryDate: this.mlsEntryDate,
      mlsEntryFailed: this.mlsEntryFailed,
      mlsEntryFailureReason: this.mlsEntryFailureReason,
    };
  }
}

/**
 * Interface for the Coming Soon PUT request payload
 */
export interface ComingSoonPhotoInput {
  uri: string;
  uploadedBy: string;
  photographerId?: string | null;
  height?: number | null;
  width?: number | null;
  thumbnails?: ComingSoonPhotoThumbnails;
  filename?: string | null;
  fileExtension?: string | null;
}

export interface ComingSoonUpdatePayload {
  photos: ComingSoonPhotoInput[];
  propertyDescription: string | null;
  companyUrl: string | null;
  mlsNumber: string | null;
  mlsEntryDate: string | null;
  mlsEntryFailed: boolean;
  mlsEntryFailureReason: string | null;
}
